"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = void 0;
class Storage {
}
exports.Storage = Storage;
//# sourceMappingURL=Storage.js.map